import { businessKey } from 'queryKeys';

export const SMART_RULES = 'smartRules';
export const ACTION_LOGS = 'actionLogs';
const srQuery = businessKey.query(SMART_RULES);

const MUTATION_START = 'start';
const MUTATION_STOP = 'stop';

const MUTATION_ACTION_APPROVE = 'actionApprove';
const MUTATION_ACTION_REJECT = 'actionReject';
const MUTATION_CALLBACK = 'callback';

export const details = srQuery.details();
export const model = srQuery.exact();

export const grids = srQuery.grids();
export const grid = srQuery.grid();

export const actionLogs = srQuery.next(ACTION_LOGS);

export const mutations = srQuery.mutations();
export const create = mutations.create();
export const start = mutations.mutate(MUTATION_START);
export const stop = mutations.mutate(MUTATION_STOP);
export const edit = mutations.update();
export const approve = mutations.approve();
export const reject = mutations.reject();
export const actionApprove = mutations.mutate(MUTATION_ACTION_APPROVE);
export const actionReject = mutations.mutate(MUTATION_ACTION_REJECT);
export const remove = mutations.delete();
export const callback = mutations.mutate(MUTATION_CALLBACK);
